import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import WOW from "wowjs";

function BannerTwo() {
    useEffect(() => {
        const wow = new WOW.WOW({ live: false });
        wow.init();
    }, []);

    const [isOpen, setIsOpen] = useState(false);
    const openVideo = () => setIsOpen(true);
    const closeVideo = () => setIsOpen(false);

    const handleKeyUp = (e) => {
        if (e.key === 'Escape') closeVideo();
    };

    // 👇 New content for banner-tag rotation
    const bannerMessages = [
  "Stay VAT compliant<br/>with expert support.",
  "Get personalized audit<br/>advice you can trust.",
  "We simplify finances<br/>for growing companies.",
  "Your business thrives<br/>with AQ's guidance."
];
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentMessageIndex((prevIndex) =>
                (prevIndex + 1) % bannerMessages.length
            );
        }, 2000); // 2 seconds
        return () => clearInterval(interval); // cleanup
    }, []);

    return (
        <div>
            <div className="banner-area banner-style-two bg_image tmp-section-gapTop">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-5 order-xl-1 order-lg-1 order-md-2 order-sm-2 order-2">
                            <div className="banner-inner wow fadeInUp" data-wow-duration=".8s" data-wow-delay=".3s">
                                <div className="sub-title" style={{ display: "block" }}>
                                    AQ Audit – Financial Expertise You Can Trust
                                </div>
                                <h2 className="title split-collab">
                                    Grow with AQ <br /> in a shifting market <br /> landscape.
                                </h2>
                                <p className="description">
                                    We help businesses thrive with expert audits and financial insight.
                                    We can also streamline your accounting and VAT compliance.
                                </p>
                                <div className="banner-bottom" style={{ gap: 30 }}>
                                    <Link to={'/About'} className="tmp-btn btn-secondary">
                                        Why AQ Auditing
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 offset-lg-2 order-xl-2 order-lg-2 order-md-1 order-sm-1 order-1">
                            <div className="banner-two-thumbnail">
                                <div className="thumbnail">
                                    <img src="assets/images/banner/banner5.png" alt="Business_Corporate" className="wow slideInRight" data-wow-duration=".8s" data-wow-delay=".1s" />
                                    {/* <div className="product-share product-share-style-two">
                                        <div className="rating">
                                            <div className="number">4.8</div>
                                            <div className="stars-group">
                                                <div className="star">
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star" />
                                                    <i className="fa-solid fa-star-half-stroke" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="profile-share">
                                            <Link to="#" className="avatar" tabIndex={0}><img src="assets/images/about/4.png" alt="education" /></Link>
                                            <Link to="#" className="avatar" tabIndex={0}><img src="assets/images/about/5.png" alt="education" /></Link>
                                            <Link to="#" className="avatar" tabIndex={0}><img src="assets/images/about/6.png" alt="education" /></Link>
                                            <Link to="#" className="avatar" tabIndex={0}><img src="assets/images/about/7.png" alt="education" /></Link>
                                        </div>
                                    </div> */}

                                    {/* 👇 Banner Tag with dynamic content and left position */}
                                    <div className="banner-tag">
                                        <div className="inner">
                                            <div className="icon bg-color-secondary radius-circle mr--20">
                                                <i className="fa-regular fa-check" />
                                            </div>
                                            <div className="content">
                                                <h3
                                                    className="title"
                                                    dangerouslySetInnerHTML={{ __html: bannerMessages[currentMessageIndex] }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Background elements */}
                <div className="bg-circle"><img src="assets/images/banner/banner-circle.png" alt="banner" /></div>
                <div className="bg-dolour"><img src="assets/images/banner/banner-dolour.png" alt="banner" /></div>
                <div className="bg-blue-circle"><img src="assets/images/banner/blue-circle.png" alt="banner" /></div>
                <div className="bg-curly-lines"><img src="assets/images/banner/curly-lines.png" alt="banner" /></div>
            </div>
        </div>
    );
}

export default BannerTwo;
